import React from 'react'
import FieldsetItem from 'components/FieldsetItem'
import Tooltip from 'components/Tooltip'
import Loading from 'components/Loading/Loading'
import FormikRadioInputField from 'components/FormikRadioInputField'
import PropTypes from 'prop-types'
import {
  Divider,
  MergeButton,
  MergeColumnWrapper,
  MergeLayoutSection,
  MergeLayoutWrapper,
  MergeColumnTitle,
} from './styles'

export default function MergeLayout(props) {
  const { mergeCustomerResults, previewMergeCustomerResults, isSubmitting } =
    props || {}
  const results = mergeCustomerResults || previewMergeCustomerResults
  const isPreview = !!previewMergeCustomerResults
  const {
    licensesNotMovedBusinessReasons = [],
    licensesNotMovedUnknownReasons = [],
    usersNotMovedUnknownReasons = [],
  } = results || {}
  const showUnmodified =
    !!licensesNotMovedBusinessReasons.length ||
    !!licensesNotMovedUnknownReasons.length ||
    !!usersNotMovedUnknownReasons.length
  const tooltipMessage =
    'Some licenses could not be modified, to avoid causing more than one instance of a Product at a Site.  Because some licenses are still using the Duplicate Customer ID, it has not be marked invalid, and will still appear in the school picker. Please fix these subscriptions / licenses, and merge again later.'
  return (
    <MergeLayoutWrapper>
      <Loading isLoading={isSubmitting} message="One Moment Please...." />
      <MergeLayoutSection>
        <MergeColumnWrapper>
          <legend>Primary Record</legend>
          <FormikRadioInputField
            disabled={props.values.activePrimaryId !== 'primaryNSCustomerId'}
            inputName="primaryNSCustomerId"
            label="NS Customer ID:"
            name="activePrimaryId"
            type="number"
            value="primaryNSCustomerId"
            {...props}
          />
          <FormikRadioInputField
            disabled={props.values.activePrimaryId !== 'primarySecondstepId'}
            inputName="primarySecondstepId"
            label="SS Customer ID:"
            name="activePrimaryId"
            type="number"
            value="primarySecondstepId"
            {...props}
          />
        </MergeColumnWrapper>
        <MergeColumnWrapper>
          <legend>Duplicate Record</legend>
          <FormikRadioInputField
            disabled={
              props.values.activeDuplicateId !== 'duplicateNSCustomerId'
            }
            inputName="duplicateNSCustomerId"
            label="NS Customer ID:"
            name="activeDuplicateId"
            type="number"
            value="duplicateNSCustomerId"
            {...props}
          />
          <FormikRadioInputField
            disabled={
              props.values.activeDuplicateId !== 'duplicateSecondstepId'
            }
            inputName="duplicateSecondstepId"
            label="SS Customer ID:"
            name="activeDuplicateId"
            type="number"
            value="duplicateSecondstepId"
            {...props}
          />
        </MergeColumnWrapper>
      </MergeLayoutSection>
      {results && (
        <React.Fragment>
          <Divider />
          <MergeLayoutWrapper>
            <legend>Customers information</legend>
            <MergeLayoutSection>
              <MergeColumnWrapper>
                <MergeColumnTitle>Primary Customer:</MergeColumnTitle>
                <FieldsetItem
                  data={results.primaryCustomer.companyName}
                  title=" Customer Name"
                />
                <FieldsetItem
                  data={
                    results.primaryCustomer.inactive ? 'Inactive' : 'Active'
                  }
                  title=" Customer Status"
                />
              </MergeColumnWrapper>
              <MergeColumnWrapper>
                <MergeColumnTitle>Duplicate Customer:</MergeColumnTitle>
                <FieldsetItem
                  data={results.duplicateCustomer.companyName}
                  title=" Customer Name"
                />
                <FieldsetItem
                  data={
                    results.duplicateCustomer.inactive ? 'Inactive' : 'Active'
                  }
                  title=" Customer Status"
                />
              </MergeColumnWrapper>
            </MergeLayoutSection>
            <Divider />
            <legend>{isPreview ? 'Merge Preview' : 'Merge Outcome'}</legend>
            <MergeLayoutSection>
              <MergeColumnWrapper>
                <legend>To Be Modified:</legend>
                <FieldsetItem
                  data={results.licensesAffectedCount}
                  title="Total Licenses moved"
                />
                <FieldsetItem
                  data={results.sitesAffectedCount}
                  title="Total Sites moved"
                />
                <FieldsetItem
                  data={results.organizationsAffectedCount}
                  title="Total Organizations moved"
                />
                <FieldsetItem
                  data={results.subscriptionsAffectedCount}
                  title="Total Subscriptions Affected"
                />
                <FieldsetItem
                  data={results.usersAffectedCount}
                  title="Total Users moved"
                />
              </MergeColumnWrapper>
              {showUnmodified ? (
                <MergeColumnWrapper>
                  <legend>
                    Left Unmodified:{' '}
                    <Tooltip title={tooltipMessage}>
                      <i className="fas fa-exclamation-circle" />
                    </Tooltip>
                  </legend>
                  {licensesNotMovedBusinessReasons.length ? (
                    <FieldsetItem title="Total Licenses Unaffected for Business Reasons">
                      {licensesNotMovedBusinessReasons.map(license => (
                        <div
                          key={license.id}
                        >{`License ID: ${license.id}, NS License Id: ${license.nsLicenseId}`}</div>
                      ))}
                    </FieldsetItem>
                  ) : null}
                  {licensesNotMovedUnknownReasons.length ? (
                    <FieldsetItem title="Total Licenses Unaffected for Unknown Reasons">
                      {licensesNotMovedUnknownReasons.map(license => (
                        <div
                          key={license.id}
                        >{`License ID: ${license.id}, NS License Id: ${license.nsLicenseId}`}</div>
                      ))}
                    </FieldsetItem>
                  ) : null}
                  {usersNotMovedUnknownReasons.length ? (
                    <FieldsetItem title="Total Users Unaffected for Unknown Reasons">
                      {usersNotMovedUnknownReasons.map(user => (
                        <div key={user.id}>{`User ID: ${user.id}`}</div>
                      ))}
                    </FieldsetItem>
                  ) : null}
                </MergeColumnWrapper>
              ) : null}
            </MergeLayoutSection>
          </MergeLayoutWrapper>
        </React.Fragment>
      )}
      <div>
        <MergeButton
          color={'#002855'}
          disabled={props.enableValidation(props)}
          onClick={() =>
            props.handleValidation(
              props.values,
              props.setSubmitting,
              props.resetForm,
            )
          }
          type="button"
        >
          Validate
        </MergeButton>
        <MergeButton
          color={'#002855'}
          disabled={props.enableSubmit(props)}
          type="submit"
        >
          Submit
        </MergeButton>
      </div>
    </MergeLayoutWrapper>
  )
}

MergeLayout.propTypes = {
  enableSubmit: PropTypes.func.isRequired,
  enableValidation: PropTypes.func.isRequired,
  handleValidation: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  mergeCustomerResults: PropTypes.shape({
    usersAffectedCount: PropTypes.number,
    licensesAffectedCount: PropTypes.number,
    subscriptionsAffectedCount: PropTypes.number,
    licensesNotMovedBusinessReasons: PropTypes.array,
    licensesNotMovedUnknownReasons: PropTypes.array,
    licensesAffected: PropTypes.array,
    usersNotMovedUnknownReasons: PropTypes.array,
  }),
  previewMergeCustomerResults: PropTypes.shape({
    usersAffectedCount: PropTypes.number,
    licensesAffectedCount: PropTypes.number,
    subscriptionsAffectedCount: PropTypes.number,
    licensesNotMovedBusinessReasons: PropTypes.array,
    licensesNotMovedUnknownReasons: PropTypes.array,
    licensesAffected: PropTypes.array,
    usersNotMovedUnknownReasons: PropTypes.array,
  }),
  resetForm: PropTypes.func.isRequired,
  setSubmitting: PropTypes.func.isRequired,
  values: PropTypes.shape({
    activeDuplicateId: PropTypes.string.isRequired,
    activePrimaryId: PropTypes.string.isRequired,
  }),
}
